import axios from 'axios'
import qs from 'qs'
import app from '../src/main'

let loginFailFlag = false
const config = process.env.NODE_ENV === 'development' ? {
  baseUrl: 'http://192.168.1.112:8199',
  // baseUrl: 'http://116.62.36.58:8199',
  // baseUrl: 'https://api.qsyhbgj.com',
  uploadUrl: 'http://qn.ep-home.com/'
} : {
  // baseUrl: 'http://116.62.36.58:8199',一直在用
  // baseUrl: 'http://47.114.110.8:8199',
  baseUrl: 'https://api.qsyhbgj.com',
  uploadUrl: 'http://qn.ep-home.com/'
}
function epApiPost (path, params = {}) {
  var phone = sessionStorage.getItem('qs_phone') || ''
  return axios({
    method: 'post',
    timeout: 15000,
    url: path.includes('://') ? path : config.baseUrl + path,
    data: qs.stringify(Object.assign({}, params)),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Bearer ' + (qs.parse(location.search.split('?')[1]).token || sessionStorage.getItem('qs_token') || ''),
      phone: phone,
      appId: 'p_web'
    }
  }).then(response => {
    return loginHandle(response)
  }).catch((e) => {
    return { data: {} }
  })
}
function epApiGet (path, params = {}) {
  var phone = sessionStorage.getItem('qs_phone') || ''
  return axios({
    method: 'get',
    url: path.includes('://') ? path : config.baseUrl + path,
    params: Object.assign({}, params),
    headers: {
      Authorization: 'Bearer ' + (qs.parse(location.search.split('?')[1]).token || sessionStorage.getItem('qs_token') || ''),
      phone: phone,
      appId: 'p_web'
    }
  }).then(response => {
    return loginHandle(response)
  }).catch((e) => {
    return {}
  })
}
function epApiFormPost (path, params = {}) {
  var phone = sessionStorage.getItem('qs_phone') || ''
  const formParam = new FormData()
  Object.keys(params).forEach(item => {
    formParam.append(item, params[item])
  })
  return axios.post(config.baseUrl + path, formParam, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + (qs.parse(location.search.split('?')[1]).token || sessionStorage.getItem('qs_token') || ''),
      phone: phone,
      appId: 'p_web'
    }
  }).then(response => {
    return loginHandle(response)
  }).catch((e) => {
    return { data: {} }
  })
}

function loginHandle (response) {
  if (response.data && response.data.code && response.data.code === 2001 && !loginFailFlag) {
    loginFailFlag = true
    app.$toast.text(response.data.message || '登陆失效，请重新登陆', {
      duration: 1800
    })
    return {}
  } else if (response.data && response.data.code && response.data.code !== 200 && response.data.code !== 2006) {
    app.$toast.text(response.data.message, {
      duration: 1800
    })
    return response.data
  } else {
    return response.data
  }
}

export default {
  /* 登录注册 */
  login (params) {
    return epApiPost('/appUser/loginOne', params)
  },
  // 在线评估
  reportReferenceProvince (params) {
    return epApiGet('/reportReference/reportReferenceProvince', params)
  },
  /* 公司名字接口 */
  companyNameEnquiry (params) {
    return epApiGet('/companyName/companyNameEnquiry', params)
  },
  // companyNameAdd (params) {
  //   return epApiFormPost('/companyName/companyNameAdd', params)
  // },
  companyNameAdd (params) {
    return epApiFormPost('/cdAppPersonnel/companyNameAdd', params)
  },
  companyNameDelete (params) {
    return epApiGet('/companyName/companyNameDelete', params)
  },
  companyNameUpdate (params) {
    return epApiFormPost('/companyName/companyNameUpdate', params)
  },
  // 环保管家 人事中心
  hbJurisdictionAdd (params) {
    return epApiFormPost('/hbJurisdiction/hbJurisdictionAdd', params)
  },
  hbJurisdictionEnquiry (params) {
    return epApiGet('/hbJurisdiction/hbJurisdictionEnquiry', params)
  },
  hbJurisdictionUpdate (params) {
    return epApiFormPost('/hbJurisdiction/hbJurisdictionUpdate', params)
  },
  hbJurisdictionDelete (params) {
    return epApiFormPost('/hbJurisdiction/hbJurisdictionDelete', params)
  },
  hbJurisdictionSearch (params) {
    return epApiFormPost('/hbJurisdiction/hbJurisdictionSearch', params)
  },
  // appUserPhone (params) {
  //   return epApiFormPost('/appUser/appUserPhone', params)
  // },
  appUserPhone (params) {
    return epApiFormPost('/cdAppPersonnel/appUserPhone', params)
  },
  appUserCompany (params) {
    return epApiGet('/appUser/appUserCompany', params)
  },
  appUserSaveCptCode (params) {
    return epApiFormPost('/appUser/text', params)
  },
  /* 人事中心接口 */
  // appUserAdd (params) {
  //   return epApiFormPost('/appUser/appUserAdd', params)
  // },
  // appUserDelete (params) {
  //   return epApiFormPost('/appUser/appUserDelete', params)
  // },
  // appUserUpdate (params) {
  //   return epApiFormPost('/appUser/appUserUpdate', params)
  // },
  appUserAdd (params) {
    return epApiFormPost('/cdAppPersonnel/appUserAdd', params)
  },
  appUserDelete (params) {
    return epApiFormPost('/cdAppPersonnel/appUserDelete', params)
  },
  appUserUpdate (params) {
    return epApiFormPost('/cdAppPersonnel/appUserUpdate', params)
  },
  annexes (params) {
    return epApiFormPost('/appUser/annexes', params)
  },
  annexesList (params) {
    return epApiFormPost('/appUser/annexesList', params)
  },
  // annexesDelete (params) {
  //   return epApiFormPost('/annexes/annexesDelete', params)
  // },
  appUserUpdateOne (params) {
    return epApiFormPost('/appUser/appUserUpdateOne', params)
  },
  // appUserEnquiry (params) {
  //   return epApiFormPost('/appUser/appUserEnquiry', params)
  // },
  appUserEnquiry (params) {
    return epApiFormPost('/cdAppPersonnel/appUserEnquiry', params)
  },
  appUserSearch (params) {
    return epApiFormPost('/appUser/appUserSearch', params)
  },
  appUserHighestPosition (params) {
    return epApiGet('/appUser/appUserHighestPosition', params)
  },
  companyNameEnquiryOne (params) {
    return epApiGet('/companyName/companyNameEnquiryOne', params)
  },
  /* 权限管理接口 */
  // jcJurisdictionAdd (params) {
  //   return epApiFormPost('/jcJurisdiction/jcJurisdictionAdd', params)
  // },
  jcJurisdictionAdd (params) {
    return epApiFormPost('/cdAppPersonnel/jcJurisdictionAdd', params)
  },
  jcJurisdictionDelete (params) {
    return epApiFormPost('/jcJurisdiction/jcJurisdictionDelete', params)
  },
  jcJurisdictionUpdate (params) {
    return epApiFormPost('/jcJurisdiction/jcJurisdictionUpdate', params)
  },
  jcJurisdictionEnquiry (params) {
    return epApiFormPost('/jcJurisdiction/jcJurisdictionEnquiry', params)
  },
  // jcJurisdictionSearch (params) {
  //   return epApiFormPost('/jcJurisdiction/jcJurisdictionSearch', params)
  // },
  jcJurisdictionSearch (params) {
    return epApiFormPost('/cdAppPersonnel/jcJurisdictionSearch', params)
  },
  // 在线评估表格
  cdEiaStatusStatistics (params) {
    return epApiGet('/cdEiaStatus/cdEiaStatusStatistics', params)
  },
  cdEiaStatusEnquiryOne (params) {
    return epApiGet('/cdEiaStatus/cdEiaStatusEnquiryOne', params)
  },
  cdEiaStatusEnquiry (params) {
    return epApiGet('/cdEiaStatus/cdEiaStatusEnquiry', params)
  },
  cdEiaStatusAdd (params) {
    return epApiFormPost('/cdEiaStatus/cdEiaStatusAdd', params)
  },
  cdEiaStatusDelete (params) {
    return epApiFormPost('/cdEiaStatus/cdEiaStatusDelete', params)
  },
  cdEiaStatusUpdate (params) {
    return epApiFormPost('/cdEiaStatus/cdEiaStatusUpdate', params)
  },
  cdEiaStatusAllUsers (params) {
    return epApiGet('/cdEiaStatus/cdEiaStatusAllUsers', params)
  },
  cdEiaStatusUpload (params) {
    return epApiFormPost('/cdEiaStatus/cdEiaStatusUpload', params)
  },
  cdEiaStatusResolution (params) {
    return epApiFormPost('/cdEiaStatus/cdEiaStatusResolution', params)
  },
  cdEiaStatusDownload (params) {
    return epApiFormPost('/cdEiaStatus/cdEiaStatusDownload', params)
  },
  cdEiaEnclosureAllEnquiry (params) {
    return epApiFormPost('/cdEiaEnclosure/cdEiaEnclosureAllEnquiry', params)
  },
  cdEiaEnclosureUpload (params) {
    return epApiFormPost('/cdEiaEnclosure/cdEiaEnclosureUpload', params)
  },
  cdEiaEnclosureDelete (params) {
    return epApiFormPost('/cdEiaEnclosure/cdEiaEnclosureDelete', params)
  },
  cdEiaEnclosureEnquiry (params) {
    return epApiFormPost('/cdEiaEnclosure/cdEiaEnclosureEnquiry', params)
  },
  companyNameByEnquiry (params) {
    return epApiFormPost('/companyName/companyNameByEnquiry', params)
  },
  cdEiaJournalAdd (params) {
    return epApiFormPost('/cdEiaEnclosure/cdEiaJournalAdd', params)
  },
  cdEiaJournalEnquiry (params) {
    return epApiGet('/cdEiaEnclosure/cdEiaJournalEnquiry', params)
  }
}
